<div
  class="cet-radio-container"
  *ngIf="data"
  [class.scroll]="scroll"
  [style.height]="scroll + 'px'"
>
  <ng-container *ngFor="let item of data">
    <div class="cet-radio-item">
      <input
        type="radio"
        [id]="item[text]"
        [name]="name"
        [value]="item[text]"
      />

      <label
        for="{{ item[text] }}"
        (click)="select(item)"
        [class.selected]="item[text] == currentValue?.[text]"
        >{{ item[text] }}</label
      >
    </div>
  </ng-container>
</div>
